// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__t5mpJ","signatureButtonsRight":"ModalSign_signatureButtonsRight__pDJlR"};